import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Navigation } from './Navigation'

export function Layout() {
  return (
    <div className="min-h-screen bg-dark flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-6 pb-20 safe-area-bottom">
        <Outlet />
      </main>
      <Navigation />
    </div>
  )
}
